import { useTranslation } from 'react-i18next';
import { usePTPConfigContext } from 'GlobalConfig.context';
import { useProgressReturnSteps } from '@pperform/pp-react-components/PpProgressIndicatorReturn';
import { ReturnShipment } from 'components/MerchantTrackingWidget/components/ReturnShipment/models/ReturnShipment.model';
import { constructReturnProgressIndicatorTheme } from 'utils/progressIndicator.utils';
import Shipment from 'interfaces/PmParcel';
import { PpProgressIndicator } from '../models';

export const useProgressReturnShipment = (baseShipment: Shipment) => {
  const { t } = useTranslation();
  const configs = usePTPConfigContext();

  const shipment = ReturnShipment.create(baseShipment);
  const progressItemThemes = constructReturnProgressIndicatorTheme(configs);

  const progressIndicator: PpProgressIndicator = useProgressReturnSteps({
    progressItemThemes,
    translation: t,
    mixedEvents: shipment.mixedEvents,
    returnTicket: shipment.returnTicket,
  });

  const { steps, activeStageIndex, theme } = progressIndicator;

  const activeStage = steps[activeStageIndex] || {};
  const iconTheme = theme.current;

  return {
    steps,
    activeStage,
    activeStageIndex,
    iconTheme,
  };
};
